import { motion, AnimatePresence } from "framer-motion";
import DiscreteSlider from "components/widgets/Slider/Slider";
import UnityActionsWindow from "../UnityActionsWindow/UnityActionsWindow";

const UnityMenu = ({ TimelineShown, isModalOpen }: { TimelineShown: boolean, isModalOpen: boolean }) => {
  return (
    <motion.div
      className="absolute w-full h-max left-0 flex items-center justify-center flex-wrap gap-8"
      initial={{ top: 68 }}
      animate={{ top: TimelineShown ? 88 : 68 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      {/* DiscreteSlider Animation */}
      <AnimatePresence>
        {TimelineShown && (
          <motion.div
            className="z-30 pointer-events-auto"
            initial={{ opacity: 1, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 1, y: -20 }}
            transition={{ duration: 0.1, ease: "easeOut" }}
          >
            <DiscreteSlider />
          </motion.div>
        )}
      </AnimatePresence>

      {/* UnityActionsWindow - No Animation Needed Here Anymore */}
      {!isModalOpen && (
        <div className="w-full flex items-center justify-center pointer-events-auto">
          <UnityActionsWindow />
        </div>
      )}
    </motion.div>
  );
};

export default UnityMenu;
